import { Component } from "react";
import { Cell, Grid } from "react-mdl";
import "../styles/ContactUs.css";
import { ContactUsForm } from "./ContactUsForm";

export class ContactUs extends Component {
  render() {
    return (
      <div className="contactus-container">
        <Grid className="contactus-grid">
          <Cell col={12}>
            <div className="contactus-title-wrapper">
              <h2 className="contactus-title">Contact Us</h2>
              <ContactUsForm />
            </div>
          </Cell>
        </Grid>
      </div>
    );
  }
}

export default ContactUs;
